var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { position: "relative" } }, [
    _c(
      "div",
      { staticClass: "tag-select" },
      [
        _c(
          "a-radio-group",
          {
            on: { change: _vm.handleChange },
            model: {
              value: _vm.type,
              callback: function ($$v) {
                _vm.type = $$v
              },
              expression: "type",
            },
          },
          [
            !_vm.showUserName && _vm.navSwitch === 0
              ? _c("a-radio-button", { attrs: { value: "dept" } }, [
                  _vm._v(" 经理部 "),
                ])
              : _vm._e(),
            !_vm.showUserName
              ? _c("a-radio-button", { attrs: { value: "deptDealer" } }, [
                  _vm._v(" 经销商 "),
                ])
              : _vm._e(),
            _vm.showUserName
              ? _c("a-radio-button", { attrs: { value: "customer" } }, [
                  _vm._v(" 销售顾问 "),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "user-box" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "div",
              { staticClass: "search-box" },
              [
                _c("a-input", {
                  attrs: { placeholder: "搜索部门" },
                  model: {
                    value: _vm.kws,
                    callback: function ($$v) {
                      _vm.kws = $$v
                    },
                    expression: "kws",
                  },
                }),
                _c(
                  "a-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onSearch } },
                  [_vm._v("搜索")]
                ),
              ],
              1
            ),
            _c("div"),
            _vm.type === "dept"
              ? _c(
                  "div",
                  { staticClass: "tree-box" },
                  [
                    _vm.navSwitch === 0
                      ? _c(
                          "a-tree",
                          {
                            attrs: {
                              checkable: "",
                              checkStrictly: "",
                              "show-icon": true,
                              expandedKeys: _vm.defaultExpandedKeys,
                              "auto-expand-parent": _vm.autoExpandParent,
                              "tree-data": _vm.regionTreeData,
                              selectable: false,
                              treeCheckStrictly: "",
                              replaceFields: {
                                children: "children",
                                title: "deptName",
                                key: "deptId",
                              },
                            },
                            on: {
                              "update:expandedKeys": function ($event) {
                                _vm.defaultExpandedKeys = $event
                              },
                              "update:expanded-keys": function ($event) {
                                _vm.defaultExpandedKeys = $event
                              },
                              check: _vm.onSelect,
                            },
                            model: {
                              value: _vm.checkedKeys,
                              callback: function ($$v) {
                                _vm.checkedKeys = $$v
                              },
                              expression: "checkedKeys",
                            },
                          },
                          [
                            _c("a-icon", {
                              staticStyle: { color: "#2fcfeb" },
                              attrs: { slot: "dealer", type: "team" },
                              slot: "dealer",
                            }),
                            _c("a-icon", {
                              staticStyle: { color: "#52c41a" },
                              attrs: { slot: "region", type: "cluster" },
                              slot: "region",
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.type === "deptDealer"
              ? _c(
                  "div",
                  { staticClass: "tree-box" },
                  [
                    _c(
                      "a-tree",
                      {
                        attrs: {
                          checkable: "",
                          checkStrictly: "",
                          "show-icon": true,
                          expandedKeys: _vm.defaultExpandedKeysDealer,
                          "auto-expand-parent": _vm.autoExpandParent,
                          "tree-data": _vm.deptDealerTreeData,
                          selectable: false,
                          treeCheckStrictly: "",
                          replaceFields: {
                            children: "children",
                            title: "deptName",
                            key: "deptId",
                          },
                        },
                        on: {
                          "update:expandedKeys": function ($event) {
                            _vm.defaultExpandedKeysDealer = $event
                          },
                          "update:expanded-keys": function ($event) {
                            _vm.defaultExpandedKeysDealer = $event
                          },
                          check: _vm.onSelect,
                        },
                        model: {
                          value: _vm.checkedKeys,
                          callback: function ($$v) {
                            _vm.checkedKeys = $$v
                          },
                          expression: "checkedKeys",
                        },
                      },
                      [
                        _c("a-icon", {
                          staticStyle: { color: "#2fcfeb" },
                          attrs: { slot: "dealer", type: "team" },
                          slot: "dealer",
                        }),
                        _c("a-icon", {
                          staticStyle: { color: "#52c41a" },
                          attrs: { slot: "region", type: "cluster" },
                          slot: "region",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.type === "customer"
              ? _c(
                  "div",
                  { staticClass: "tree-box" },
                  [
                    _c("Tree", {
                      attrs: {
                        list: _vm.treeData,
                        selectedUser: _vm.selectedUser,
                        userName: _vm.kws,
                        detph: 0,
                      },
                      on: { change: _vm.checkedUser },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "right" }, [
            _c("div", [_vm._v("已选择")]),
            _vm.type === "dept"
              ? _c(
                  "ul",
                  { staticClass: "selected" },
                  _vm._l(_vm.selectedData, function (item) {
                    return _c(
                      "li",
                      { key: item.key },
                      [
                        _c("span", [_vm._v(_vm._s(item.deptName))]),
                        _c("a-icon", {
                          attrs: { type: "close" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteItem(item.deptId)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.type === "deptDealer"
              ? _c(
                  "ul",
                  { staticClass: "selected" },
                  _vm._l(_vm.selectedData, function (item) {
                    return _c(
                      "li",
                      { key: item.key },
                      [
                        _c("span", [_vm._v(_vm._s(item.deptName))]),
                        _c("a-icon", {
                          attrs: { type: "close" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteItem(item.deptId)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.type === "customer"
              ? _c(
                  "ul",
                  { staticClass: "selected" },
                  _vm._l(_vm.selectedUser, function (item) {
                    return _c(
                      "li",
                      { key: item.userId },
                      [
                        _c("span", [_vm._v(_vm._s(item.userName))]),
                        _c("a-icon", {
                          attrs: { type: "close" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteUser(item.userId)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }